import React from 'react'
import tenderHeart from './tenderHeart.jpg'
import lowrence from './lowrence.jpg'
import RNTI from './RNTI.png'


export default function Qualification(props) {
  return (
    <div id='di2' style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}}>

      

      <div className="imgScroll">
        <h1 className='degreeHead' style={{color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}}>DEGREE</h1>
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators" >
    <button  type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
    <h2 className="degree" style={{color:`${props.mode==='light'?'rgb(11, 117, 117)':'rgb(83, 80, 80)'}`}} >
                      <span style={{ color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}} >Tender Heart School </span> (High School)
                    </h2>
      <img src={tenderHeart}  className="d-block w-100" alt="..." />
    </div>
    <div className="carousel-item">
        <h2 className="degree" style={{color:`${props.mode==='light'?'rgb(11, 117, 117)':'rgb(83, 80, 80)'}`}} >
                      <span style={{ color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}} >Lowerence Inter College </span> (intermediate)
                    </h2>
      <img src={lowrence} className="d-block w-100" alt="..." />
      
    </div>
    <div className="carousel-item">
    <h2 className="degree" style={{color:`${props.mode==='light'?'rgb(11, 117, 117)':'rgb(83, 80, 80)'}`}} >
                      <span style={{ color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}} >Rabindra Nath Tagore University </span> (Graduate)
                    </h2>
      <img src={RNTI} className="d-block w-100" alt="..." />
    </div>
  </div>
  <button  className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span  className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button  className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
</div>


          <h1 className="skilHead">
            <span className="wordSkill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}}>SKILLS </span>
            </h1>

          <div className="skills">
            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src='https://puneetchaubey-portfolio.netlify.app/Images/html.png' alt="" />
              <h2>HTML</h2>
            </div>

            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src='https://puneetchaubey-portfolio.netlify.app/Images/css.png' alt="" />
              <h2>CSS</h2>
            </div>

            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src="https://puneetchaubey-portfolio.netlify.app/Images/js.png" alt="" />
              <h2>JAVASCRIPT</h2>
            </div>

            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src="https://puneetchaubey-portfolio.netlify.app/Images/react.png" alt="" />
              <h2>REACT</h2>
            </div>
        </div>

        <h1 className="toolHead">
            <span className="wordAbout" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'rgb(11, 117, 117)'}`}}>TOOLS </span>
            </h1>
        
            <div className="tools">
            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src='https://puneetchaubey-portfolio.netlify.app/Images/vs.png' alt="" />
              <h2>VS CODE</h2>
            </div>

            <div className="skill" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`, color:`${props.mode==='light'?'white':'#000028'}`}}>
              <img src="https://rangav.gallerycdn.vsassets.io/extensions/rangav/vscode-thunder-client/1.20.0/1665574521881/Microsoft.VisualStudio.Services.Icons.Default" alt="" />
              <h2>THINDER CLINT</h2>
            </div>
        </div>
       
        <div className="blank"></div>

    </div>
  )
}
